import React from 'react';
import { Row, Col } from 'reactstrap';
import "./../../../css/affiliate.css";
import bannerimage from "../../../assets/affiliate/bannerimage.png";
import callApi from '../../../utils/apiCaller';


const TopBanner = () => {
    const handleClickMode = (note) => {
		let params = {
			action: "clickReview",
			type: "click_affiliate_top",
			note: note,
		};
		callApi("get", params).then(async (res) => {});
	};
    return (
        <div className="st-affiliate-top-banner">
            <Row>
                <Col lg={7}>
                    <div>
                        <h1>Refer friends</h1>
                        <h2> {'&'} Get reward </h2>
                        <h6>Spread the love and earn 20% recurring commissions for every new referral.</h6>
                        <div>
                            <a
                                href="https://platform.shoffi.app/signup/affiliate?app=Il_VwAn8snq"
                                target="_blank"
                            >
                                <button
                                    className="affiliate-button-primary"
                                    onClick={()=> handleClickMode("btn_join_now")}
                                >Join now</button>
                            </a>
                            <a
                                href="https://platform.shoffi.app/login" target="_blank"
                            >
                                <button
                                    className="affiliate-button-secondary"
                                    onClick={()=> handleClickMode("btn_login")}
                                >Login</button>
                            </a>
                        </div>
                    </div>
                </Col>
                <Col lg={5}>
                    <div className="st-affiliate-top-banner-img">
                        <img src={bannerimage} alt="synctrack affiliate" />
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default TopBanner;